import React from "react";
import { X } from "lucide-react";

import SectionAccordion from "./SectionAccordion";
import "./CourseSidebar.css";

export default function CourseSidebar({
    sections,
    currentContentId,
    onSelectContent,
    scormNavigation,
    onSelectScormNode,
    sidebarOpen,
    onCloseSidebar,
}) {
    return (
        <aside className={`cs-sidebar ${sidebarOpen ? "cs-sidebar--open" : ""}`}>
            <header className="cs-sidebar__header">
                <h2>Contenu du cours</h2>
                <button type="button" className="cs-sidebar__close" onClick={onCloseSidebar}>
                    <X size={20} />
                </button>
            </header>

            <nav className="cs-sidebar__sections" aria-label="Programme du cours">
                {(sections || []).map((section, index) => (
                    <SectionAccordion
                        key={section.id}
                        section={section}
                        sectionNumber={index + 1}
                        currentContentId={currentContentId}
                        onSelectContent={onSelectContent}
                        scormNavigation={scormNavigation}
                        onSelectScormNode={onSelectScormNode}
                    />
                ))}
            </nav>
        </aside>
    );
}
